import React from "react";
import { useNavigate } from "react-router-dom";
import data1 from "../../data/home1/projects/projects1.json";

function Projects() {
  const navigate = useNavigate();

  const handleClick = (item, index) => {
    navigate("/innerpages/single_project", {
      state: { project: item, index: item.projectId },
    });
  };

  return (
    <section style={{ padding: "40px 0", background: "#fff" }}>
      
      {/* TITLE */}
      <h2
        style={{
          textAlign: "center",
          marginBottom: "40px",
          fontWeight: "600",
          letterSpacing: "1px",
        }}
      >
        Featured Projects
      </h2>

      {/* FULL WIDTH */}
      <div
        style={{
          width: "100%",
          padding: "0 40px",
        }}
      >
        {/* GRID */}
        <div className="grid-container">
          {data1.map((item, i) => (
            <div
              key={i}
              onClick={() => handleClick(item, i)}
              className="grid-card"
            >
              <img src={item.img} alt="" className="grid-img" />

              {/* OVERLAY */}
              <div className="grid-overlay">
                <h3 className="grid-title">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* STYLES */}
      <style>
        {`
        /* GRID */
        .grid-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 12px;
        }

        /* CARD */
        .grid-card {
          position: relative;
          overflow: hidden;
          height: 220px;
          cursor: pointer;
          border-radius: 0;
          box-shadow: 0 6px 20px rgba(0,0,0,0.08);
          transition: 0.3s ease;
        }

        /* HOVER LIFT */
        .grid-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.15);
        }

        /* IMAGE */
        .grid-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 0;
          transition: transform 0.6s ease;
        }

        .grid-card:hover .grid-img {
          transform: scale(1.08);
        }

        /* 🔥 WHITE CENTER OVERLAY */
        .grid-overlay {
          position: absolute;
          inset: 0;
          background: rgba(255,255,255,0.95);

          display: flex;
          align-items: center;
          justify-content: center;

          opacity: 0;
          transition: 0.4s ease;
        }

        .grid-card:hover .grid-overlay {
          opacity: 1;
        }

        /* 🔥 CURSIVE TEXT CENTER */
        .grid-title {
          font-size: 28px;
          color: #000;
          font-family: "Brush Script MT", cursive;
          text-align: center;
          letter-spacing: 1px;

          transform: scale(0.9);
          transition: 0.3s ease;
        }

        .grid-card:hover .grid-title {
          transform: scale(1);
        }

        /* MOBILE */
        @media (max-width: 600px) {
          .grid-container {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        `}
      </style>
    </section>
  );
}

export default Projects;
